// extracted by mini-css-extract-plugin
export default {"OrganizationDocumentsFilters":"OrganizationDocumentsFilters_OrganizationDocumentsFilters__fwUNi"};